module.exports = __webpack_public_path__ + "img/bg@2x.f714681c.png";